import { render, staticRenderFns } from "./InvitePermissionPage.vue?vue&type=template&id=65bf919c&scoped=true&"
import script from "./InvitePermissionPage.vue?vue&type=script&lang=js&"
export * from "./InvitePermissionPage.vue?vue&type=script&lang=js&"
import style0 from "./InvitePermissionPage.vue?vue&type=style&index=0&id=65bf919c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bf919c",
  null
  
)

export default component.exports